import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Nav } from "./Nav";
import { Footer } from "./Footer";
import { ConsentBanner } from "./ConsentBanner";
import { Seo } from "@/seo/Seo";
import { STATIC_META } from "@/seo/config";
import { captureAttribution, trackEvent } from "@/lib/attribution";

const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "auto" }); }, [pathname]);
  return null;
};

const Track = () => {
  const { pathname } = useLocation();
  useEffect(() => { captureAttribution(); }, []);
  useEffect(() => { trackEvent("page_view", { service_page: pathname }); }, [pathname]);
  return null;
};

// Pages that render their own <Seo> (with schema) — skip the layout fallback for these.
const SELF_SEO = new Set(["/", "/services", "/insights"]);

const LayoutSeo = () => {
  const { pathname } = useLocation();
  if (SELF_SEO.has(pathname)) return null;
  const meta = STATIC_META[pathname];
  if (!meta) return null;
  return <Seo path={pathname} title={meta.title} description={meta.description} />;
};

export const SiteLayout = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white antialiased selection:bg-cyan-400/20">
      <ScrollToTop />
      <Track />
      <LayoutSeo />
      <Nav />
      <main>
        <Outlet />
      </main>
      <Footer />
      <ConsentBanner />
    </div>
  );
};
